// 下载白名单
export const downloadWhitelist = [
    '13032130528', // 阿迪达斯（百秋新网商），客户编号42459
    '13750824941', // 测试账号
    '13665608670', // 测试账号
    '18072715286', // 测试账号
]